import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sub_tab_menu" }
const _hoisted_2 = { class: "sub_tab_menu_lst" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
        return (_openBlock(), _createBlock("li", {
          key: index,
          class: ["menu", _ctx.activated(link)]
        }, [
          _createVNode(_component_router_link, {
            to: link.routing,
            class: "menu_link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.text), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ], 2))
      }), 128))
    ])
  ]))
}